module.exports = __webpack_public_path__ + "img/building95-6.7d78fbf7.jpg";